import { render } from "./TotalAnualPrevistoGarantePayView.vue?vue&type=template&id=7fb4f87b&scoped=true"
import script from "./TotalAnualPrevistoGarantePayView.vue?vue&type=script&lang=js"
export * from "./TotalAnualPrevistoGarantePayView.vue?vue&type=script&lang=js"

import "./TotalAnualPrevistoGarantePayView.vue?vue&type=style&index=0&id=7fb4f87b&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb4f87b"]])

export default __exports__